import React from 'react';
import { FormattedMessage } from 'react-intl';
import { PrivateFeedContainer, LockIcon, PrivateFeedTitle, PrivateFeedBody, LockIconContainer, } from './styles';
const PrivateFeed = () => {
    return (React.createElement(PrivateFeedContainer, null,
        React.createElement(LockIconContainer, null,
            React.createElement(LockIcon, null)),
        React.createElement(PrivateFeedTitle, null,
            React.createElement(FormattedMessage, { id: "privateFeed.title" })),
        React.createElement(PrivateFeedBody, null,
            React.createElement(FormattedMessage, { id: "privateFeed.body" }))));
};
export default PrivateFeed;
//# sourceMappingURL=index.js.map